import React from 'react';

const OPTIONS = [
  { value: 'all', label: 'Todos' },
  { value: 'active', label: 'Solo activos' },
  { value: 'inactive', label: 'Solo inactivos' },
];

export default function StatusFilterTabs({ value, onChange }) {
  return (
    <div className="flex rounded-lg bg-gray-100 border border-gray-200 p-0.5">
      {OPTIONS.map((opt) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
            value === opt.value
              ? 'bg-black text-white'
              : 'text-gray-500 hover:text-gray-900 hover:bg-gray-200'
          }`}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
}

export { OPTIONS as STATUS_FILTER_OPTIONS };
